<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-12 m-0 no-max-w home-div">
          <AstopiaTable ref="astopiaTable" :columns="columns" :url="'/admin/customize-content/story-list'"
                        :default-post-data="'?test=test'"
                        :axiosDataName="'response'" :sort-field="'id'" :totalDataName="'totalCount'"
                        @detail-see="detailSee" @delet-see="deleteSee" @add-button="addInAppMessage"  :addButton="'Add Customize Content'" :getLookupsButton="'Preview Create'" @getLookups-button="previewCreate"/>

          <CreateModal
              :show="showCreateModal"
              modalTitle="Create customize content"
              modalWidth="50%"
              :formFields="[
                { label: 'Content Type', type: 'text', model: 'contentType', placeholder: 'Enter title', popoverText: 'Format olarak - ile yazılabilir.(ör: aries-weekly). Appteki content typelar', required: false },
                { label: 'Story Title', type: 'text', model: 'storyTitle', popoverText: 'Story yuvarlağının altındaki metin (ör: Senin dünyan)', required: false },
                { label: 'Icon Url', type: 'text', model: 'iconUrl', popoverText: 'Story yuvarlağında kullanılan foto', required: false },
                { label: 'Static Story List', type: 'objProperties', model: 'staticStoryList', obj: [{ label: 'Title', type: 'text', model: 'title', popoverText: 'Contentin üzerindeki başlık', required: false },{ label: 'Description', type: 'text', model: 'description', popoverText: 'Contentin içeriği', required: false },{ label: 'Language', type: 'drop', model: 'language', placeholder: 'Enter language', options: supportedLanguages , id: 'id', value: 'name' },{ label: 'Deep Link Button Text', type: 'text', model: 'deepLinkButtonText', required: false },{ label: 'Deep Link Button Url', type: 'text', model: 'deepLinkButtonUrl', required: false }], placeholder: 'Enter option', popoverText: 'Story içeriği eklemek için bu alan kullanılacaktır. Her story içeriği, + simgesine tıklanarak eklenebilir. Eklenen içerikler, alt kısımda listelenecektir. Tekli veya çoklu ekleme seçenekleri mevcuttur.', required: true },
                { label: 'Is Static', type: 'switch', model: 'isStatic',popoverText: 'AI çalışmadığında yada ai dışıda story datalarını ekleyebilin diye var', required: true },
                { label: 'Is Active', type: 'switch', model: 'isActive',popoverText: 'Aktif mi Değil mi False çekersen story görünürden gider', required: false }
              ]"
              @saveEndpoint="createObj"
              method="post"
              @hide="showCreateModal = false"
              @success="refreshTable"
          />

          <CreateModal
              :show="showPreviewCreateModal"
              modalTitle="Create preview create"
              modalWidth="50%"
              :formFields="[
                { label: 'Language', type: 'drop', model: 'language', placeholder: 'Enter language', options: supportedLanguages , id: 'id', value: 'name' },
                { label: 'rawAstrologicalContent', type: 'textarea', model: 'rawAstrologicalContent', required: false },
                { label: 'path', type: 'text', model: 'path', required: false }
              ]"
              @saveEndpoint="previewCreateObj"
              method="post"
              @hide="showPreviewCreateModal = false"
              @success="refreshTable"
          />

          <EditModal
              :show="showEditModal"
              modalTitle="Edit customize content"
              modalWidth="50%"
              :formFields="[
                { label: 'Content Type', type: 'text', model: 'contentType', placeholder: 'Enter type', required: false },
                { label: 'Title', type: 'text', model: 'title', required: false },
                { label: 'Icon Url', type: 'switch', model: 'iconUrl', required: false },
                { label: 'Is Active', type: 'switch', model: 'isActive', required: false },
                { label: 'Customize Content Stories', type: 'properties', model: 'customizeContentStories', placeholder: 'Enter option', required: true },
              ]"
              :detailEndpoint="`admin/customize-content/story/${selectedObjId}`"
              @saveEndpoint="editObj"
              method="put"
              :totalDataName="'response'"
              :isOnlydata="true"
              @hide="showEditModal = false"
          />


          <DeleteModal
              :show="showDeleteModal"
              :itemId="selectedDeleteId"
              modalTitle="Delete survey"
              deleteMessage="Are you sure you want to delete this customize content?"
              confirmButtonText="Yes"
              :deleteEndpoint="`/admin/customize-content/story-delete/${selectedDeleteId}`"
              @update:isVisible="showDeleteModal = false"
              @delete-success="refreshTable"
          />

        </div>
      </div>
    </div>
  </main>
</template>
<script>
import AstopiaTable from "../../components/Tables/AstopiaTable.vue";
import {mapGetters} from "vuex";

export default {
  components: {AstopiaTable},
  data(){
    return {
      columns: [
        {field: "contentType", header: "Content Type", functionType: "none",selected: true},
        {field: "title", header: "Title", functionType: "none", selected: true},
        {field: "iconUrl", header: "Icon Url", functionType: "none", selected: true},
        {field: "isActive", header: "Is Active", functionType: "bool", selected: true},
        {field: "customizeContentStories", header: "Customize Content Stories", functionType: "json", selected: true},
        {field: "Actions", header: "Actions", functionType: "crud", edit: false, delete: true, selected: true},
      ],
      data:{
        "contentType": "string",
        "storyTitle": "string",
        "iconUrl": "string",
        "staticStoryList": [
          {
            "title": "string",
            "description": "string",
            "language": "string",
            "deepLinkButtonText": "string",
            "deepLinkButtonUrl": "string"
          }
        ],
        "isStatic": true,
        "isActive": true
      },
      previewData:{
        "language": "",
        "rawAstrologicalContent": "",
        "path": ""
      },
      dataUpdate:{
        "title": "string",
        "description": "string",
        "isMultiAnswer": true,
        "isPremium": true,
        "options": [
          "string"
        ]
      },
      showModalCrud: false,
      showCreateModal: false,
      showPreviewCreateModal: false,
      showEditModal: false,
      showDeleteModal: false,
      selectedDeleteId: null,
      selectedObjId: null,
      dialogTypes: null
    }
  },
  computed: {
    ...mapGetters(['supportedLanguages']),
  },
  created() {
    this.$appAxios.get("/admin/in-app-message/dialog-types").then((res) => {
      this.dialogTypes = res.data;
    });
  },
  methods: {
    addInAppMessage() {
      this.showCreateModal = true
    },
    previewCreate() {
      this.$router.push('/preview-create')
    },
    createObj(obj) {
      this.data.contentType = obj.contentType;
      this.data.storyTitle = obj.storyTitle;
      this.data.iconUrl = obj.iconUrl;
      this.data.staticStoryList = obj?.staticStoryList;
      this.data.isStatic = obj?.isStatic;
      this.data.isActive = obj.isActive;
      this.$appAxios.post("/admin/customize-content/story-create", this.data).then(() => {
        this.refreshTable()
        this.showCreateModal = false
      }).catch(() => {
        this.showCreateModal = false
      })
    },
    previewCreateObj(obj) {
      this.previewData.language = obj.language;
      this.previewData.rawAstrologicalContent = obj.rawAstrologicalContent;
      this.previewData.path = obj.path;
      this.$appAxios.post("/admin/customize-content/preview-create", this.previewData).then(() => {
        this.refreshTable()
        this.showPreviewCreateModal = false
      }).catch(() => {
        this.showPreviewCreateModal = false
      })
    },
    detailSee(obj){
      this.selectedObjId = obj.id
      this.showEditModal = true
    },
    editObj(obj) {
      this.dataUpdate.title = obj.title;
      this.dataUpdate.description = obj.description;
      this.dataUpdate.isMultiAnswer = obj.isMultiAnswer;
      this.dataUpdate.isPremium = obj.isPremium;
      this.dataUpdate.options = obj?.options;
      this.$appAxios.put(`/admin/Survey/survey/update/${this.selectedObjId}`, this.dataUpdate).then(() => {
        this.refreshTable()
        this.showEditModal = false
      }).catch(err => {
        console.log(err)
        this.showEditModal = false
      })
    },
    getLookups(){
      this.showModalCrud = true
    },
    deleteSee(report) {
      this.selectedDeleteId = report.id
      this.showDeleteModal = true
    },
    refreshTable() {
      this.$refs.astopiaTable.getData();
    }
  }
}
</script>

